const questionTypes = {
  RADIO_LIST: 'RadioList',
  TEXTAREA: 'Textarea',
  INPUT: 'Input',
  STAR_RATING: 'StarRating',
  MULTIPLE_SELECT: 'MultipleSelect',
  NET_PROMOTER_SCORE: 'NetPromoterScore'

  // Not using these types in the WAP:

  // DATE_PICKER: 'DatePicker',
  // SELECT: 'Select',
  // CHECKBOX: 'Checkbox',
  // CHECKLIST: 'Checklist'
};

const answerTypes = {
  BOOLEAN: 'Boolean',
  NUMBER: 'Number',
  TEXT: 'Text',
  DATE: 'Date'
};

const questionAnswerMap = {
  [questionTypes.RADIO_LIST]: answerTypes.TEXT,
  [questionTypes.TEXTAREA]: answerTypes.TEXT,
  [questionTypes.INPUT]: answerTypes.TEXT,
  [questionTypes.STAR_RATING]: answerTypes.NUMBER,
  [questionTypes.MULTIPLE_SELECT]: answerTypes.TEXT,
  [questionTypes.NET_PROMOTER_SCORE]: answerTypes.TEXT

  // Not using these types in the WAP:

  // [questionTypes.DATE_PICKER]: answerTypes.DATE,
  // [questionTypes.SELECT]: answerTypes.TEXT,
  // [questionTypes.CHECKBOX]: answerTypes.BOOLEAN,
  // [questionTypes.CHECKLIST]: answerTypes.TEXT
};

const netPromoterScoreOptions = [
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 1,
    value: 0
  },
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 2,
    value: 1
  },
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 3,
    value: 2
  },
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 4,
    value: 3
  },
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 5,
    value: 4
  },
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 6,
    value: 5
  },
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 7,
    value: 6
  },
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 8,
    value: 7
  },
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 9,
    value: 8
  },
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 10,
    value: 9
  },
  {
    isActive: true,
    isUnsaved: true,
    sortOrder: 11,
    value: 10
  }
];

export {
  questionTypes,
  answerTypes,
  questionAnswerMap,
  netPromoterScoreOptions
};
